import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import { Button, Loader } from '@mantine/core';

const ExportExcelButton = ({ data, fileName = 'student-details.xlsx' }) => {
  const [loading, setLoading] = useState(false);

  // Preload image and check if it loads
  const checkImageExists = (url) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = url;
    });
  };

  const handleExport = async () => {
    if (!data || data.length === 0) {
      alert('No data to export');
      return;
    }

    setLoading(true);

    const header = ['Sr.No.', 'Name', 'Batch Code', 'Photo URL', 'Created At'];

    // Pre-check all images
    const checkedRows = await Promise.all(
      data.map(async (student, index) => {
        const imageUrl = student.photo1 
          ? `https://ppxxub.online/apis/image-proxy.php?name=${student.photo1}`
          : null;

        let photoCell;
        if (imageUrl) {
          const exists = await checkImageExists(imageUrl);
          if (exists) {
            photoCell = { f: `HYPERLINK("${imageUrl}", "View Photo")` };
          } else {
            photoCell = { v: 'Image upload pending', s: { font: { color: { rgb: 'FF0000' } } } };
          }
        } else {
          photoCell = { v: 'Image upload pending', s: { font: { color: { rgb: 'FF0000' } } } };
        }

        return [
          index + 1,
          student.name,
          student.batch_code,
          photoCell,
          new Date(student.created_at).toLocaleString(),
        ];
      })
    );

    // Create worksheet
    const worksheet = XLSX.utils.aoa_to_sheet([header, ...checkedRows]);

    worksheet['!cols'] = [
      { wch: 8 },   // Sr.No.
      { wch: 25 },  // Name
      { wch: 20 },  // Batch Code
      { wch: 50 },  // Photo URL
      { wch: 25 },  // Created At
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Student Details');

    XLSX.writeFile(workbook, fileName);

    setLoading(false);
  };

  return (
    <Button color="blue" variant="outline" onClick={handleExport} disabled={loading}>
      {loading ? <Loader size="xs" color="blue" /> : 'Export Excel'}
    </Button>
  );
};

export default ExportExcelButton;
